<template>
  <div class="personnels">
    <div v-if="change == 0">
      <div class="intro-y box p-5 mt-5" >
        <div class="asset-page-content">
          <div class="intro-y box p-5 mt-5">
            <div class="personnels-title">人员管理</div>
            <div class="search-form">
              <el-form :form="form" inline>
                <el-form-item label="人员名称">
                  <el-input v-model='form.name' placeholder="请输入员工名称" style="width:230px;"/>
                </el-form-item>
                <el-form-item label="人员账号">
                  <el-input v-model='form.mobile' placeholder="请输入员工账号" style="width:230px;"/>
                </el-form-item>
                <el-form-item label="启用状态">
                  <el-select style="width: 140px" v-model='form.status' @change="sourceChange" placeholder="请选择">
                    <el-option
                            v-for="item in unitOptions"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" style="margin-right:10px;" @click="seek" :loading="loading">
                    搜寻
                  </el-button>
                  <el-button type="primary" @click="addAsset">
                    +新增人员
                  </el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="intro-y overflow-auto mt-2">
            <table class="table table-report ">
              <thead>
              <tr>
                <th class="whitespace-no-wrap">人员姓名</th>
                <th class="whitespace-no-wrap">人员账号</th>
                <th class="whitespace-no-wrap">所属公司</th>
                <th class="whitespace-no-wrap">角色</th>
                <th class="whitespace-no-wrap">启用状态</th>
                <th class="whitespace-no-wrap">创建时间</th>
                <th class="whitespace-no-wrap">操作</th>
              </tr>
              </thead>
              <tbody>
              <tr
                      v-for="(item, index) in modele"
                      :key="index"
                      class="intro-x"
              >
                <td>
                  <div class="font-medium whitespace-no-wrap">{{
                    item.name
                    }}
                  </div>
                </td>
                <td>
                  <div class="font-medium whitespace-no-wrap">{{
                    item.mobile
                    }}
                  </div>
                </td>
                <td>
                  <div class="font-medium whitespace-no-wrap">{{
                    item.companyName
                    }}
                  </div>
                </td>
                <td>
                  <div class="font-medium whitespace-no-wrap">
                <span v-for="(v,index) in item.roleNameList" :key="index">
                  <span v-if="index!=0">,</span>
                  {{ v }}
                </span>
                  </div>
                </td>
                <td>
                  <div class="font-medium whitespace-no-wrap">{{
                    item.status ? '启用' : '禁用'
                    }}
                  </div>
                </td>
                <td>
                  <div class="font-medium whitespace-no-wrap">{{
                    item.createTime
                    }}
                  </div>
                </td>
                <td class="table-report__action whitespace-no-wrap">
                  <div class="flex  items-center">
                    <a class="flex items-center mr-3" href="javascript:;" v-if="item.status" @click='changeStatus(item)'>
                      禁用
                    </a>
                    <a class="flex items-center mr-3" href="javascript:;" v-else @click='changeStatus(item)'>
                      启用
                    </a>
                    <a class="flex items-center mr-3" href="javascript:;" @click='checkHandle(item)'>
                      编辑
                    </a>
                  </div>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div
              class="intro-y col-span-12 flex flex-wrap sm:flex-row sm:flex-no-wrap items-center justify-space-between mt-5"
      >
        <el-pagination
                layout="prev, pager, next"
                :background='false'
                :page-size="pagination.perPage"
                :current-page="pagination.page"
                @current-change="handleTableChange"
                :total="pagination.total">
        </el-pagination>
        <select class="w-20 input box mt-3 sm:mt-0" @change='onShowSizeChange' v-model='pagination.perPage'>
          <option :value='10'>10</option>
          <option :value='25'>25</option>
          <option :value='35'>35</option>
          <option :value='50'>50</option>
        </select>
      </div>
    </div>
    <div class="intro-y box p-5 mt-5" v-if="change == 1">
      <div class="asset-page-content" style="display: flex;padding: 10px 0 0 0">
        <div class="add-l">
          <div class="add-title">{{ fex }}人员</div>
        </div>
        <div class="add-r">
          <div style="line-height: 46px;font-size: 20px;font-weight: bold;padding-bottom: 10px;">人员信息</div>
          <div>
            <el-form
                ref="ruleForm"
                :rules="rules"
                :model="ruleForm"
                :wrapper-col="wrapperCol"
                label-width='140px'
            >
              <el-form-item style="margin-bottom: 10px" label="人员姓名" prop='name' labelAlign="left" layout="vertical">
                <el-input v-model="ruleForm.name" style="width: 450px" placeholder="请输入人员姓名"/>
              </el-form-item>
              <el-form-item style="margin-bottom: 10px" label="人员账号" labelAlign="left" layout="vertical" prop='mobile'>
                <el-input v-model="ruleForm.mobile" style="width: 450px" placeholder="请输入人员账号"/>
              </el-form-item>
              <el-form-item style="margin-bottom: 10px" label="登录密码" labelAlign="left" layout="vertical"
                            prop='password'>
                <el-input type="password" v-model="ruleForm.password" style="width: 450px" placeholder="请输入登陆密码"/>
              </el-form-item>
              <el-form-item style="margin-bottom: 10px" label="邮箱" labelAlign="left" layout="vertical" prop="email">
                <el-input v-model="ruleForm.email" style="width: 450px" placeholder="请输入邮箱"/>
              </el-form-item>
              <el-form-item label="启用状态:"  prop='status'>
                <el-radio-group v-model="ruleForm.status" style="padding-left: 10px">
                  <el-radio label="1" name="type">
                    启用
                  </el-radio>
                  <el-radio label="0" name="type">
                    停用
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="领导角色状态:" style="margin-bottom: 10px;" prop='adminFlag'>
                <el-radio-group v-model="ruleForm.adminFlag" style="padding-left: 10px">
                  <el-radio label="1" name="type">
                    是
                  </el-radio>
                  <el-radio label="0" name="type">
                    否
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="角色权限" style="margin-bottom: 22px;" prop='roleIdList'>
                <el-transfer
                    :data="mockData"
                    :list-style="{
                    width: '230px',
                    height: '270px',
                  }"
                    :titles="['可供选择的角色', '已选择的角色']"
                    v-model="targetKeys"
                    @change="handleChange"
                />
              </el-form-item>
              <el-form-item label="特殊权限" style="margin-bottom: 10px;">
                <el-transfer
                    :data="mockData2"
                    :list-style="{
                    width: '230px',
                    height: '270px',
                  }"
                    :titles="['可选择特殊权限', '已选择的特殊权限']"
                    v-model="targetKeys2"
                    @change="handleChange2"
                />
              </el-form-item>
              <el-form-item label="备注">
                <el-input v-model="ruleForm.memo" style="width: 450px" type="textarea"/>
              </el-form-item>
              <el-form-item style="padding-left: 100px;padding-top: 10px">
                <el-button @click="submitData();">
                  确定
                </el-button>
                <el-button type="primary" @click="changeFex()" style="margin-left: 10px;">
                  取消
                </el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {getList, toggle, permission, specail, addUser, reviseUser, getDetail} from "../../api/organization";

export default {
  name: "personnels",
  components: {},
  data() {
    let validateMobile = (rule, value, callback) => {
      let reg = /^(0|86|17951)?(13[0-9]|15[012356789]|166|17[3678]|18[0-9]|14[57])[0-9]{8}$/
      if (!value) {
        callback(new Error('手机号不能为空'));
      } else {
        if (!reg.test(value)) {
          callback(new Error('手机号格式错误'));
        } else {
          callback();
        }
      }
    }
    return {
      mockData: [],
      mockData2: [],
      targetKeys: [],
      targetKeys2: [],
      selectedKeys: [],
      selectedKeys2: [],
      disabled: false,
      labelCol: {span: 4},
      wrapperCol: {span: 14},
      rules: {
        name: [
          {required: true, message: '请输入人员名称', trigger: 'blur'},
        ],
        mobile: [
          {required: true, validator: validateMobile, trigger: 'blur'},
        ],
        password: [
          {required: true, message: '请输入账号密码', trigger: 'blur'},
          {min: 6, message: '密码长度不能低于6位', trigger: 'blur'},
        ],
        email: [
          {type: 'email', message: '请输入正确的邮箱', trigger: 'blur'},
        ],
        status: [
          {required: true, message: '请选择启用状态', trigger: 'blur'},
        ],
        adminFlag: [
          {required: true, message: '请选择领导角色状态', trigger: 'blur'},
        ],
        roleIdList: [
          {required: true, message: '请选择角色权限', trigger: 'blur'},
        ],
      },
      ruleForm: {
        name: '',
        mobile: '',
        password: '',
        email: '',
        memo: '',
        status: '1',
        adminFlag: '1',
        roleIdList: [],
      },
      change: 0,
      fex: "新增",
      unitOptions: [
        {id: '', name: '全部状态'},
        {id: '0', name: '未启用'},
        {id: '1', name: '启用'},
      ],
      form: {
        name: '',
        mobile: '',
        status: '',
      },
      pagination: {
        page: 1,
        total: 0,
        perPage: 10,
      },
      loading: false,
      modele: [],
    }

  },
  methods: {

    //清除验证
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    handleChange(currentVal, direction, moveKeys) {
      this.ruleForm.roleIdList = this.targetKeys;
      if(this.targetKeys.length>0){
        this.$refs.ruleForm.clearValidate(['roleIdList'])
      }
    },
    handleChange2(currentVal, direction, moveKeys) {
    },
    onShowSizeChange(e) {
      this.pagination.page = 1;
      this.getList();
    },
    //查找
    seek() {
      this.pagination.current = 1;
      this.getList();
    },
    //拉取列表
    getList() {
      let para = this.form;
      para.page = this.pagination.page;
      para.perPage = this.pagination.perPage;
      this.loading = true;
      getList(para).then(res => {
        this.loading = false
        let data = res.data
        if (data.code === '000') {
          this.modele = data.content.list;
          this.pagination.total = data.content.total;
        } else {

        }
      }).catch(err => {
        this.loading = false
        console.log(err);
      }).finally(() => {
        this.loading = false
      })
    },
    //修改状态
    changeStatus(data) {
      let para = '';
      console.log(data.status);
      if (data.status) {
        para = {
          id: data.id,
          status: false,
        };
      } else {
        para = {
          id: data.id,
          status: true,
        };
      }
      toggle(para).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.$message.success('修改成功');
          this.getList();
        } else {
          this.$message.error(data.desc);
        }
      }).catch(err => {
        this.loading = false
        console.log(err);
      }).finally(() => {
        this.loading = false
      })
    },
    submitData() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let para = JSON.parse(JSON.stringify(this.ruleForm));
          para.status = Number(para.status)
          para.adminFlag = !!Number(para.adminFlag)
          para.roleIdList = this.targetKeys;
          para.permissionIdList = this.targetKeys2;
          if (this.fex == '修改') {
            reviseUser(para).then(res => {
              let data = res.data;
              if (data.code === '000') {
                this.$message.success('修改成功');
                this.changeFex();
                this.getList();
              } else {
                this.$message.error(data.desc);
              }
            }).catch(err => {
              console.log(err);
            }).finally(() => {

            })
          } else {
            addUser(para).then(res => {
              let data = res.data;
              if (data.code === '000') {
                this.$message.success('添加成功');
                this.changeFex();
                this.getList();
              } else {
                this.$message.error(data.desc);
              }
            }).catch(err => {
              console.log(err);
            }).finally(() => {

            })
          }
        } else {
          return false;
        }
      });
    },
    //切换到添加修改
    changeFex() {
      this.change = 0;
      this.resetForm();
    },
    changeFex2() {
      this.change = 1;
    },
    addAsset() {
      this.fex = '新增';
      this.changeFex2();
      this.ruleForm = {
        name: '',
        mobile: '',
        password: '',
        email: '',
        memo: '',
        status: '1',
        adminFlag: '1',
        roleIdList: [],
      };
      this.targetKeys2 = [];
      this.rules.password = [
        {required: true, message: '请输入账号密码', trigger: 'blur'},
        {min: 6, message: '密码长度不能低于6位', trigger: 'blur'},
      ]
    },
    checkHandle(record) {
      this.fex = '修改';
      this.rules.password = [
        {min: 6, message: '密码长度不能低于6位', trigger: 'blur'},
      ]
      this.changeFex2();
      this.ruleForm = {
        name: '',
        mobile: '',
        password: '',
        email: '',
        memo: '',
        status: '1',
        adminFlag: '1',
        roleIdList: [],
      };
      this.targetKeys2 = [];
      let para = {
        id: record.id,
      }
      getDetail(para).then(res => {
        let data = res.data;
        if (data.code === '000') {
          this.ruleForm = data.content;
          if (data.content.status) {
            this.ruleForm.status = '1';
          } else {
            this.ruleForm.status = '0';
          }
          if (data.content.adminFlag) {
            this.ruleForm.adminFlag = '1';
          } else {
            this.ruleForm.adminFlag = '0';
          }
          this.targetKeys = [];
          this.targetKeys2 = [];
          for (let i = 0; i < data.content.roleIdList.length; i++) {
            this.targetKeys.push(data.content.roleIdList[i].toString());
          }
          // this.ruleForm.roleIdList = this.targetKeys
          for (let i = 0; i < data.content.permissionIdList.length; i++) {
            this.targetKeys2.push(data.content.permissionIdList[i].toString());
          }
        } else {
          this.$message.error(data.desc);
        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {

      })
    },
    getPermission() {
      let para = {
        status: 1,
        page: 1,
        perPage: 100,
      };
      permission(para).then(res => {
        let data = res.data;
        if (data.code === '000') {
          let list = data.content.list;
          let mockData = [];
          for (let i = 0; i < list.length; i++) {
            mockData.push({
              key: list[i].id.toString(),
              label: list[i].name,
              disabled: false,
              description: list[i].name,
            });
          }
          this.mockData = mockData;
        } else {

        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {

      })
      specail().then(res => {
        let data = res.data;
        if (data.code === '000') {
          let list = data.content.list;
          let mockData = [];
          for (let i = 0; i < list.length; i++) {
            mockData.push({
              key: list[i].id.toString(),
              label: list[i].authorityName,
              disabled: false,
              description: list[i].authorityName,
            });
          }
          this.mockData2 = mockData;
        } else {

        }
      }).catch(err => {
        console.log(err);
      }).finally(() => {

      })
    },
    toggle() {
      console.log(this.form)
    },
    handleTableChange(page) {
      this.pagination.page = page;
      this.getList();
    },
    sourceChange(val) {
      console.log(val)
    },
  },
  created() {
    this.getList();
    this.getPermission();
  },
}
</script>

<style scoped lang="scss">
.personnels-title {
  font-size: 20px;
  font-weight: bold;
  padding-bottom: 20px;
  padding-top: 20px;
}

.search-form {

}

.add-l {
  width: 200px;

  .add-title {
    background-color: #e9f7fe;
    line-height: 46px;
    padding-left: 25px;
    font-size: 14px;
    border-right: 3px solid #4390f7;
    color: #4390f7;
  }
}

.add-r {
  flex: 1;
  padding-left: 25px;
  border-left: 1px solid rgba(235, 235, 235, 1);
}

</style>
